<script setup>
import {ref} from "vue";

const pendingNotificationsList = ref()

const onNotificationCreated = () => {
    pendingNotificationsList.value.loadNotifications()
}

</script>
<template>
    <div class="pt-8">
        <whitelabel-app-notification-list
            ref="pendingNotificationsList"
            class="mb-8"
        />
        <whitelabel-app-notification-composer
            @created="onNotificationCreated"
        />
    </div>
</template>
